export enum ColorOptions {
  BLACK = '000000',
  JADE_WHITE = 'F1EDEA',
  RED = 'C42227',
  BLUE = '0A2989',
  DARK_BLUE = '000080',
  BAMBU_GREEN = '16C443',
  SUNFLOWER_YELLOW = 'FEC601',
  INDIGO_PURPLE = '482A60',
  PUMPKIN_ORANGE = 'FF8E15',
  COCOA_BROWN = '6F5035',
  GOLD = 'F4A925',
}
export enum BeadColorOptions {
  WHITE = 'FFFFFF',
  BLACK = '000000'
}